import SearchColumnKeyword from "@/views/list/components/SearchColumnKeyword.vue";

const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-start-end",
        label: "작성일",
        value: "date",
        query: { ss: "startDate", ee: "endDate" },
        options: {
          default: { sd: "", ed: "" },
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ['점검기간', "작성일"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  작성일
    if (search.date) {
      conditions.push({ key: "created_at", operator: ">=", value: search.date.startDate });
      conditions.push({ key: "created_at", operator: "<", value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : "" });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "점검대상 시설명",
        key: "body.대상부서명",
      },
      // {
      //   "name": "팀명",
      //   "key": "field.team_company_list[%].com_name",
      //   "sortKey": false
      // },
      {
        name: "점검기간",
        key: "body.stdInfo.rank",
      },
      {
        name: "작성자",
        key: "body.stdInfo.writer_name",
      },
      {
        name: "작성일",
        key: "created_at",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: { // 점검대상시설명
          const fields = func.getContent(value).점검대상시설명.map((item) => {
            return item.field_name;
          });
          return fields.join(", ");
        }
        case 1: {
          const 점검기간 = func.getContent(value).점검기간;
          if (점검기간) {
            const start = new Date(점검기간.sDate).format("yyyy-MM-dd");
            const end = new Date(점검기간.eDate).format("yyyy-MM-dd");
            return `${start} ~ ${end}`;
          }
          return "" // 점검기간
        }
        case 2: return func.getContent(value).stdInfo.writer_name; // 작성자
        case 3: return func.getCreatedDate(value.created_at); // 작성일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
